<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>{{title}} đề xuất: {{request.name}}</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <mat-form-field class="full" appearance="outline" [color]="color" *ngIf="forward == false">
            <mat-label>Phản hồi tới @{{request.submitterUser.username}}</mat-label>
            <textarea matInput [(ngModel)]="description"></textarea>
        </mat-form-field>
      <div *ngIf="forward == true">
        <mat-label style="font-weight: bold">Chuyển tiếp tới</mat-label>
        <one-user-select label="Sử dụng @ để tag thành viên nhận"
                         [allUsers]="users"
                         [oneControl]="targetUserFormControl"></one-user-select>
        <mat-error style="margin-top: -15px" *ngIf="hasError">Bạn phải chọn người nhận đề xuất này</mat-error>
        <mat-form-field class="full" appearance="outline" [color]="color">
          <mat-label>Gửi tin nhắn cho người nhận đề xuất này</mat-label>
          <textarea matInput [(ngModel)]="description"></textarea>
        </mat-form-field>

      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close *ngIf="forward == false">Hủy bỏ</button>
        <button mat-raised-button [color]="color" (click)="onSend()" *ngIf="forward == false">{{title}} đề xuất này</button>
      <button mat-raised-button class="agreeFwdBtn" color="warn" (click)="onAgreeFwd(true)" *ngIf="forward == true">Đồng ý và Chuyển tiếp</button>
      <button mat-raised-button class="agreeBtn" color="primary" (click)="onAgreeFwd(false)" *ngIf="forward == true">Chuyển tiếp</button>
    </mat-dialog-actions>
</div>
